import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/organisms/Header';
import Footer from '../components/organisms/Footer';
import OGP from '../components/mixin/ogp';

interface Props {
  children: any;
}

const Layout = (props: Props) => (
  <div>
    <Helmet
      htmlAttributes={{
        lang: 'ja',
      }}
    >
      <meta charSet="utf-8" />
      <meta
        name="description"
        content=" -仕事に夢を、日本に野望を。- 日本をもう一度、強く輝く、経済大国に。すべての変化は、いつだって、想いからはじまる。私たちは、それぞれが仕事に夢をもって働けるための事業を通じて、ひとつひとつの会社に成長を届けます。そして、その積み重ねによって、野望にあふれる次の日本への道を支えていきます。"
      />
    </Helmet>
    <OGP />
    <Header />
    {props.children}
    <Footer />
  </div>
);

export default Layout;
